export const bannerStyle = {
  fontWeight: 700,
  fontamily: 'Roboto',
  padding: '8px 16px',
  borderRadius: '3px',
  textAlign: 'center',
  width: '52px'
}


// WEBPACK FOOTER //
// ./src/components/Banner/banner-styles.js